/* ============================================================
   Yoganica — product page
   ============================================================ */
(function () {
  'use strict';

  /* ---------- gallery + in-place hover zoom ---------- */
  var slides = [].slice.call(document.querySelectorAll('.slide'));
  var thumbs = [].slice.call(document.querySelectorAll('.thumb'));
  var stage = document.getElementById('stage');

  function activeSlide() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('on')) return slides[i];
    }
    return null;
  }
  function activeImg() {
    var s = activeSlide();
    return s ? s.querySelector('img[data-zoom]') : null;
  }
  function refreshZoomable() {
    if (!stage) return;
    var img = activeImg();
    stage.classList.toggle('zoomable', !!img);
    if (!img) stage.classList.remove('zooming');
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = t.getAttribute('data-i');
      slides.forEach(function (s) { s.classList.toggle('on', s.getAttribute('data-i') === i); });
      thumbs.forEach(function (x) { x.classList.toggle('on', x === t); });
      if (stage) stage.classList.remove('zooming');
      var img = activeImg();
      if (img) img.style.transformOrigin = 'center center';
      refreshZoomable();
    });
  });
  refreshZoomable();

  if (stage) {
    stage.addEventListener('mouseenter', function () {
      if (activeImg()) stage.classList.add('zooming');
    });
    stage.addEventListener('mouseleave', function () {
      stage.classList.remove('zooming');
      var img = activeImg();
      if (img) img.style.transformOrigin = 'center center';
    });
    stage.addEventListener('mousemove', function (e) {
      var img = activeImg();
      if (!img) { stage.classList.remove('zooming'); return; }
      if (!stage.classList.contains('zooming')) stage.classList.add('zooming');
      var r = stage.getBoundingClientRect();
      var px = Math.max(0, Math.min((e.clientX - r.left) / r.width, 1)) * 100;
      var py = Math.max(0, Math.min((e.clientY - r.top) / r.height, 1)) * 100;
      img.style.transformOrigin = px + '% ' + py + '%';
    });
  }

  /* ---------- accordion ---------- */
  document.querySelectorAll('.ai button').forEach(function (b) {
    b.addEventListener('click', function () {
      var item = b.parentElement;
      var body = item.querySelector('.body');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.ai').forEach(function (x) {
        x.classList.remove('open');
        var bd = x.querySelector('.body');
        if (bd) bd.style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });
  var firstOpen = document.querySelector('.ai.open .body');
  if (firstOpen) firstOpen.style.maxHeight = firstOpen.scrollHeight + 'px';

  /* ---------- quantity ---------- */
  var qty = 1;
  var qEl = document.getElementById('q');
  var qInput = document.getElementById('qtyInput');
  function setQty(n) {
    qty = Math.max(1, Math.min(n, 99));
    if (qEl) qEl.textContent = qty;
    if (qInput) qInput.value = qty;
  }
  var plus = document.getElementById('pl');
  var minus = document.getElementById('mi');
  if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });
  if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });

  /* ---------- variant selection ---------- */
  var variants = window.YOGANICA_VARIANTS || [];
  var variantInput = document.getElementById('variantId');
  var priceEl = document.getElementById('price');
  var wasEl = document.getElementById('was');
  var saveEl = document.querySelector('.saveb');
  var atc = document.getElementById('atc');
  var sbp = document.getElementById('sbp');

  function money(cents) {
    try { return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 }); }
    catch (e) { return '₹' + Math.round(cents / 100); }
  }

  function selectedOptions() {
    var out = [];
    document.querySelectorAll('.swatches').forEach(function (group) {
      var on = group.querySelector('.sw.on');
      out.push(on ? on.getAttribute('data-option-value') : null);
    });
    return out;
  }

  function findVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], match = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] && v.options[j] !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function updateVariant() {
    var v = findVariant(selectedOptions());
    if (!v) return;
    if (variantInput) variantInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (sbp) sbp.textContent = money(v.price);

    if (v.compare_at_price && v.compare_at_price > v.price) {
      if (wasEl) { wasEl.textContent = money(v.compare_at_price); wasEl.style.display = ''; }
      if (saveEl) {
        saveEl.style.display = '';
        saveEl.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
      }
    } else {
      if (wasEl) wasEl.style.display = 'none';
      if (saveEl) saveEl.style.display = 'none';
    }

    if (atc) {
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Add to cart' : 'Sold out';
    }

    // reflect chosen media if the variant has its own image
    if (v.featured_media && slides.length) {
      var pos = v.featured_media.position - 1;
      var target = slides.filter(function (s) { return +s.getAttribute('data-i') === pos; })[0];
      if (target) {
        slides.forEach(function (s) { s.classList.remove('on'); });
        target.classList.add('on');
        thumbs.forEach(function (t) { t.classList.toggle('on', +t.getAttribute('data-i') === pos); });
        refreshZoomable();
      }
    }

    // keep the URL in sync so refresh/share keeps the variant
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  }

  document.querySelectorAll('.swatches .sw').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var group = sw.parentElement;
      group.querySelectorAll('.sw').forEach(function (x) { x.classList.remove('on'); });
      sw.classList.add('on');
      var idx = group.getAttribute('data-option-index');
      var label = document.querySelector('[data-option-label="' + (parseInt(idx, 10) + 1) + '"]');
      if (label) label.textContent = sw.getAttribute('data-option-value');
      updateVariant();
    });
  });

  /* ---------- selling plans ---------- */
  document.querySelectorAll('#plans .pl').forEach(function (p) {
    p.addEventListener('click', function () {
      document.querySelectorAll('#plans .pl').forEach(function (x) { x.classList.remove('on'); });
      p.classList.add('on');
      var radio = p.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    });
  });

  /* ---------- AJAX add to cart ---------- */
  var form = document.getElementById('productForm');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = variantInput ? variantInput.value : null;
      if (!id) return;
      var planEl = form.querySelector('input[name="selling_plan"]:checked');
      var body = { items: [{ id: parseInt(id, 10), quantity: qty }] };
      if (planEl && planEl.value) body.items[0].selling_plan = parseInt(planEl.value, 10);

      if (atc) { atc.disabled = true; atc.textContent = 'Adding…'; }
      var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (er) { throw new Error(er.description || 'Could not add'); });
          return r.json();
        })
        .then(function () {
          if (window.yoganicaRefreshCart) window.yoganicaRefreshCart();
          if (window.yoganicaToast) window.yoganicaToast(qty + ' × added to cart');
        })
        .catch(function (err) {
          if (window.yoganicaToast) window.yoganicaToast(err.message);
        })
        .then(function () {
          if (atc) { atc.disabled = false; atc.textContent = 'Add to cart'; }
        });
    });
  }

  var sbadd = document.getElementById('sbadd');
  if (sbadd && form) {
    sbadd.addEventListener('click', function () {
      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  /* ---------- sticky bar visibility ---------- */
  var buybox = document.querySelector('.buybox');
  var sb = document.getElementById('sb');
  if (buybox && sb && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { sb.classList.toggle('on', !e.isIntersecting); });
    }, { threshold: 0 }).observe(buybox);
  }
})();
